import { HeartFilled, StarFilled, UserOutlined } from '@ant-design/icons';
import { CSSProperties } from 'react';
import { AccessTier } from 'services/api/models/UserDTO';
import { colors } from 'design';

const PATIENT_ACCESS_TIER_CONFIG = {
  LICENSE_CODE: {
    Icon: StarFilled,
    iconColor: colors.accessTier.licenseCode,
  },
  APP_SUBSCRIPTION: {
    Icon: HeartFilled,
    iconColor: colors.accessTier.appSubscription,
  },
  FREE: {
    Icon: UserOutlined,
    iconColor: colors.accessTier.free,
  },
} as const satisfies Record<AccessTier, { Icon: typeof StarFilled; iconColor: string }>;

type PatientAccessTierIconProps = {
  accessTier: AccessTier;
  className?: string;
  style?: CSSProperties;
};

export default function PatientAccessTierIcon({ accessTier, className, style }: PatientAccessTierIconProps) {
  const { Icon, iconColor } = PATIENT_ACCESS_TIER_CONFIG[accessTier];
  return <Icon className={className} style={{ color: iconColor, ...style }} />;
}
